import React from 'react'
import { useSelector } from 'react-redux'

const Milestone = ({year, text}) => {
  return (
    <div className="mb-5 lg:mb-8">
      <p className="text-gray-999 text-xs">{year}</p>
      <p className="text-gray-444 text-sm">{text}</p>
    </div>
  )
}

const Milestones = ({data}) => {
  const language = useSelector(state => state.system.language)

  return (
    <div className="mb-5 lg:mb-0 p-5 lg:p-8" style={{background: '#f5f5f5'}}>
      <h3 className="font-bold lg:text-lg font-accent mb-5 lg:mb-6 uppercase">Milestones</h3>
      {
        (data && data.length > 0) &&
        data.map((d, i) => (
          <Milestone key={i} year={d.year} text={d[`description_${language.name}`]}/>
        ))
      }

      {/* <Milestone year={2009} text="Sunt in ad tempor deserunt tempor velit incididunt occaecat ea laboris in pariatur amet nulla."/>
      <Milestone year={2011} text="Ullamco id nisi ut Lorem Lorem minim commodo ipsum non proident occaecat."/>
      <Milestone year={2018} text="Culpa eiusmod nisi exercitation
      quis deserunt duis veniam mollit ullamco excepteur irure eiusmod."/>
      <Milestone year={2019} text="Ullamco id nisi ut Lorem Lorem minim commodo ipsum non proident occaecat."/>
      <Milestone year={2020} text="Culpa eiusmod nisi exercitation quis deserunt duis veniam mollit ullamco excepteur irure eiusmod."/> */}
    </div>
  )
}

export { Milestones }
